import { useAccessToken } from '@/features/auth/state/auth'
import api from '@/lib/api'
import { useQuery } from '@tanstack/react-query'

export function useFetchAllAgreementByIdClient(id_client?: string, opts?: { enabled?: boolean }) {
  const token = useAccessToken()
  return useQuery({
    queryKey: ['agreements', 'byClient', id_client],
    enabled: !!id_client && (opts?.enabled ?? true),
    queryFn: async () => {
      if (id_client == ``) return []

      const response = await api.get(`agreement/minutas-client/${id_client}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data?.data ?? response.data
      } else {
        throw new Error('Estrutura de resposta inesperada')
      }
    }
  })
}
